import React from "react";
import cn from "classnames";

type Props = {
  className?: string;
};

/** Burbuja con tres puntos (estilo Crisp), pensada para FAB azul con trazo blanco. */
export default function SupportChatLauncherIcon({ className }: Props) {
  return (
    <svg
      className={cn("wsc-fab__icon", className)}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        stroke="currentColor"
        strokeWidth="2.15"
        strokeLinejoin="round"
        strokeLinecap="round"
        d="M9.5 8.5h13a3.25 3.25 0 0 1 3.25 3.25v6.25A3.25 3.25 0 0 1 22.5 21.25H15l-3.75 3.5V21.25H9.5a3.25 3.25 0 0 1-3.25-3.25v-6.25A3.25 3.25 0 0 1 9.5 8.5Z"
      />
      <circle cx="13.25" cy="14.75" r="1.45" fill="currentColor" />
      <circle cx="17.5" cy="14.75" r="1.45" fill="currentColor" />
      <circle cx="21.75" cy="14.75" r="1.45" fill="currentColor" />
    </svg>
  );
}
